export const DECIMAL_TO_PERCENT = 100;
export const PERCENT_TO_DECIMAL = 1 / DECIMAL_TO_PERCENT;
